import type { BugReport } from '../../app/bug-reports'
import type { CreateDevelopmentTaskInput } from '../../app/development-tasks'

export function bugTaskDraft(report:BugReport, origin:string):Partial<CreateDevelopmentTaskInput> {
  const analysis=report.analysis
  const repairPlan=analysis?.repair_plan?.trim()
  const hasRelevantPlan=Boolean(repairPlan)
  return {
    title:`修复：${(report.description||'用户截图反馈').replace(/\s+/g,' ').slice(0,100)}`,
    instructions:[`反馈编号：${report.id}`,report.description,`复现页面：${report.page_url||report.route}`,hasRelevantPlan?`后台修复建议：\n${repairPlan}`:'',`生产 SHA：${report.production_sha||'未记录'}`,'实际代码分析升为黄／红级时停止自动修复，转管理员确认；红级须 owner 批准。'].filter(Boolean).join('\n\n'),
    acceptance_criteria:[{text:'按反馈截图及描述复现问题；修复后原问题不再出现，并补充回归验证。',source:'user' as const}],
    context_items:[{kind:'reference',title:'原始 Bug 反馈',locator:`${origin}/projects/${report.project_id}/bug-reports#${report.id}`},...(report.has_screenshot?[{kind:'asset' as const,title:'用户反馈截图（需项目查看权限）',locator:`${origin}/api/v1/bug-reports/${report.id}/screenshot`}]:[])],
  }
}
